import {
  RefObject, useEffect, useMemo, useState,
} from 'react'

export default function useOnScreen(
  ref: RefObject<HTMLElement | null>,
  deps: unknown[] = [],
  rootMargin = '0px',
) {
  const [isIntersecting, setIntersecting] = useState(false)

  const observer = useMemo(
    () =>
      new IntersectionObserver(
        ([entry]) => {
          setIntersecting(entry.isIntersecting)
        },
        { rootMargin },
      ),
    [ref],
  )

  useEffect(() => {
    setTimeout(() => {
      if (ref.current) {
        observer.observe(ref.current)
      }
    }, 100)
    return () => observer.disconnect()
  }, deps)

  return isIntersecting
}
